<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useRuntimeConfig } from '#app'; // Import useRuntimeConfig from Nuxt

interface Props {
  name: string;
  size?: 'mobile' | 'desktop';
}

const props = defineProps<Props>();

const bgColor = ref('');
const textColor = ref('#FFFFFF'); 


onMounted(() => {
  setBgColorBasedOnApiUrl(); // Call the new function to set color
});


function setBgColorBasedOnApiUrl() {
  const runtimeConfig = useRuntimeConfig();
  const apiUrl = runtimeConfig.public.API_URL;

  switch (apiUrl) {
    case 'https://backoffice.lotogreen.com':
      bgColor.value = '#1DBF24';
      break;
    case 'https://app.goldebet.com':
      bgColor.value = '#FFBF0D';
      break;
    case 'https://app.br4bet.com':
      bgColor.value = '#05B305';
      break;
    default:
      bgColor.value = '#CCCCCC'; 
      break;
  }
}


const fontSize = computed(() => {
  if (!props.name) return 'text-sm';
  
  const length = props.name.length;
  if (length < 10) return 'text-md';
  if (length < 20) return 'text-sm';
  return 'text-xs';
});


const containerStyle = computed(() => {
  return {
    backgroundColor: bgColor.value,
    color: textColor.value,
  };
});
</script>

<template>
  <div 
    class="h-full w-full rounded-md flex items-center justify-center overflow-hidden"
    :style="containerStyle"
  >
    <div class="text-center p-4 w-full">
      <div :class="[fontSize, 'font-bold break-words']">{{ name }}</div>
    </div>
  </div>
</template>